module.exports = __webpack_public_path__ + "static/media/notes-icon.5c22f7d2.svg";